import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Empty } from 'antd';
import { Button } from 'components/Button';
import { getIssuancesApi } from 'api/services/uniformManagement';
import { formatDateHandler } from 'utils/common';
import { getStatusBadge } from '../../constants';
import Breadcrumbs from 'components/Breadcrumbs';

const MyUniformsList = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(() => {
    setLoading(true);
    getIssuancesApi({ page_size: 100, mine: true })
      .then(response => {
        setData(response.data?.results || []);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { fetchData(); }, [fetchData]);

  if (loading) {
    return (
      <div className="page-wrapper">
        <div className="content container-fluid text-center py-5">
          <i className="fa fa-spinner fa-spin fa-2x" />
        </div>
      </div>
    );
  }

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <Breadcrumbs maintitle="My Uniforms" />

        {data.length === 0 ? (
          <div className="card">
            <div className="card-body py-5">
              <Empty description="You don't have any uniform issuances yet." />
            </div>
          </div>
        ) : (
          <div className="row">
            {data.map(item => (
              <div key={item.id} className="col-md-6 col-lg-4 mb-3">
                <div className="card h-100">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-start mb-2">
                      <h6 className="mb-0">{item.uniform_item_name}</h6>
                      <span style={getStatusBadge(item.status)}>{item.status}</span>
                    </div>

                    {item.uniform_item_image && (
                      <div className="text-center mb-2">
                        <img src={item.uniform_item_image} alt={item.uniform_item_name}
                          style={{ maxWidth: '100%', maxHeight: 120, objectFit: 'contain' }} />
                      </div>
                    )}

                    <div className="small text-muted mb-1">
                      <strong>Size:</strong>{' '}
                      {item.size_detail ? `${item.size_detail.name} (${item.size_detail.code})` : '—'}
                    </div>
                    <div className="small text-muted mb-1">
                      <strong>Qty:</strong> {item.quantity}
                    </div>
                    <div className="small text-muted mb-1">
                      <strong>Issued:</strong> {formatDateHandler(item.issuance_date)}
                    </div>
                    {item.next_replacement_date && (
                      <div className="small text-muted mb-1">
                        <strong>Replacement due:</strong> {formatDateHandler(item.next_replacement_date)}
                      </div>
                    )}

                    {item.status === 'ISSUED' && (
                      <div className="alert alert-warning py-2 px-3 mt-2 small mb-2">
                        <i className="fa fa-exclamation-triangle me-1" />
                        Awaiting your confirmation.
                      </div>
                    )}

                    <div className="d-flex gap-2 mt-3">
                      <Button
                        label={item.status === 'ISSUED' ? 'Review & Confirm' : 'View'}
                        icon={item.status === 'ISSUED' ? 'fa fa-check-circle' : 'fa fa-eye'}
                        className={`btn btn-sm ${item.status === 'ISSUED' ? 'btn-primary' : 'btn-outline-primary'} w-100`}
                        onClick={() => navigate(`/uniform-management/issuance/${item.id}`)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MyUniformsList;
